import { ElMessage, ElScrollbar } from 'element-plus'
import store from '@/store'

// 日期格式化
export function parseTime(time, pattern) {
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/')
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr.replace(new RegExp(/-/gm), '/')
}

// 返回项目路径
export function getNormalPath(p) {
  if (p.length === 0 || !p || p == 'undefined') {
    return p
  }
  const res = p.replace('//', '/')
  if (res[res.length - 1] === '/') {
    return res.slice(0, res.length - 1)
  }
  return res
}

/**
 * 时间戳转时间格式(毫秒级)
 * @param {*} time
 * @returns
 */
// export function getTimestampConversion(timestamp) {
export function getTimestampConversion(time, pattern) {
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}:{j}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/')
    }
    if (typeof time === 'number' && time.toString().length === 13) {
      time = time
    } else {
      time = time
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
    j: date.getMilliseconds()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a|j)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 13) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr.replace(new RegExp(/-/gm), '/')
}

/**
 * 时间转时间戳
 * @param {String} time 时间
 * @return {Object} 时间戳
 *
 * 例如：
 * getTimestamp('2017-01-12'); // 1484222693
 */
export function getTimestamp(time) {
  if (time == null) {
    return null
  }
  return new Date(time.replace(/-/g, '/')).getTime()
}

// 自定义时间(单位小时)
export function getTimeByHour(timeData) {
  if (timeData.time >= 0) {
    let times = 0
    switch (timeData.type) {
      case 'y':
        times = parseTime(
          new Date(
            new Date().setFullYear(new Date().getFullYear() - timeData.time)
          )
        )
        break
      // 单位月
      case 'm':
        times = parseTime(
          new Date(new Date().setMonth(new Date().getMonth() - timeData.time))
        )
        break
      // 单位天
      case 'd':
        times = parseTime(
          new Date(new Date().getTime() - 60 * 60 * 1000 * 24 * timeData.time)
        )
        break
      // 单位小时
      case 'h':
        times = parseTime(
          new Date(new Date().getTime() - 60 * 60 * 1000 * timeData.time)
        )
        break
      // 单位分钟
      case 'i':
        times = parseTime(
          new Date(new Date().getTime() - 60 * 1000 * timeData.time)
        )
        break
      // 单位秒
      case 's':
        times = parseTime(new Date(new Date().getTime() - 1000 * timeData.time))
        break
    }
    return times
  } else {
    ElMessage.error('参数错误')
    return false
  }
}

/**
 * 快捷时间选择器
 */
export const quickSelectTime = {
  近半小时: () => {
    const cur = new Date().getTime()
    return [cur - 30 * 60 * 1000, cur]
  },
  近2小时: () => {
    const cur = new Date().getTime()
    return [cur - 2 * 60 * 60 * 1000, cur]
  },
  近1天: () => {
    const cur = new Date().getTime()
    return [cur - 24 * 60 * 60 * 1000, cur]
  },
  近7天: () => {
    const cur = new Date().getTime()
    return [cur - 7 * 24 * 60 * 60 * 1000, cur]
  },
  近一个月: () => {
    const cur = new Date().getTime()
    return [cur - 30 * 24 * 60 * 60 * 1000, cur]
  }
}

// 将毫秒转化为 天时分

export function getDuration(times) {
  let my_time
  if (Array.isArray(times)) {
    my_time = times[0]
  } else {
    my_time = times
  }
  let time
  let secondF3 = 0
  let days = my_time / 1000 / 60 / 60 / 24
  let daysRound = Math.floor(days)
  let hours = my_time / 1000 / 60 / 60 - 24 * daysRound
  let hoursRound = Math.floor(hours)
  let minutes = my_time / 1000 / 60 - 24 * 60 * daysRound - 60 * hoursRound
  let minutesRound = Math.floor(minutes)
  let seconds =
    my_time / 1000 -
    24 * 60 * 60 * daysRound -
    60 * 60 * hoursRound -
    60 * minutesRound
  secondF3 = Math.round(seconds * 1000) / 1000
  if (secondF3 === 0) {
    time = my_time + 'ms'
  } else {
    if (minutesRound === 0) {
      time = secondF3.toFixed(2)
    } else {
      if (hoursRound === 0) {
        time = minutesRound + '分' + secondF3.toFixed(2)
      } else {
        time = hoursRound + '时' + minutesRound + '分' + secondF3.toFixed(2)
      }
    }
  }
  return time
}

//
export function getTimeList(item) {
  const now = new Date() // 当前日期
  const nowDayOfWeek = now.getDay() // 今天本周的第几天
  const nowDay = now.getDate() // 当前日
  const nowMonth = now.getMonth() // 当前月
  const nowYear = now.getFullYear() // 当前年
  let times = 0
  switch (item) {
    case 'toDay':
      times = parseTime(new Date(new Date().setHours(0, 0, 0, 0)))
      break
    case 'toWeek':
      times = parseTime(new Date(nowYear, nowMonth, nowDay - nowDayOfWeek))
      break
    case 'half':
      times = parseTime(new Date(new Date().getTime() - 60 * 60 * 500))
      break
    case 'oneHour':
      times = parseTime(new Date(new Date().getTime() - 60 * 60 * 1000))
      break
    case 'oneDay':
      times = parseTime(new Date(new Date().getTime() - 60 * 60 * 1000 * 24))
      break
    case 'sevenDay':
      times = parseTime(
        new Date(new Date().getTime() - 60 * 60 * 1000 * 24 * 7)
      )
      break
    case '15day':
      times = parseTime(
        new Date(new Date().getTime() - 60 * 60 * 1000 * 24 * 15)
      )
      break
    case 'mouth':
      times = parseTime(
        new Date(new Date().setMonth(new Date().getMonth() - 1))
      )
      break
    case 'year':
      times = parseTime(
        new Date(new Date().setFullYear(new Date().getFullYear() - 1))
      )
      break
    case 'ninetyDay':
      times = parseTime(
        new Date(new Date().setMonth(new Date().getMonth() - 3))
      )
      break
  }
  console.log(times)
  return times
}

// 一年前
// export function getTimeYear() {
//   return parseTime(
//     new Date(new Date().setFullYear(new Date().getFullYear() - 1))
//   )
// }
// 90天前
// export function getTimeYear() {
//   return parseTime(
//     new Date(new Date().setFullYear(new Date().getFullYear() - 1))
//   )
// }
// 半小时前
export function getTimeHalf() {
  return parseTime(new Date(new Date().getTime() - 60 * 60 * 500))
}

// 一小时前
export function getTimeOneHour() {
  return parseTime(new Date(new Date().getTime() - 60 * 60 * 1000))
}

// 24小时前
export function getTimeOneDay() {
  return parseTime(new Date(new Date().getTime() - 60 * 60 * 1000 * 24))
}

// 7天前
export function getTimeSevenDay() {
  return parseTime(new Date(new Date().getTime() - 60 * 60 * 1000 * 24 * 7))
}

// 获取当前时间的时间戳
export function getTimeNowData() {
  const nowDate = parseTime(new Date())
  return getTimestamp(nowDate)
}

// 格式：XXXX年XX月XX日XX时XX分XX秒 星期X
const complement = function (value) {
  return value < 10 ? `0${value}` : value
}

export const formateDate = (date) => {
  const time = new Date(date)
  const year = time.getFullYear()
  const month = complement(time.getMonth() + 1)
  const day = complement(time.getDate())
  const hour = complement(time.getHours())
  const minute = complement(time.getMinutes())
  const second = complement(time.getSeconds())
  const week = '星期' + '日一二三四五六'.charAt(time.getDay())
  return `${year}年${month}月${day}日 ${week} ${hour}:${minute}:${second}`
}

export const formateDateWeek = (date) => {
  const time = new Date(date)
  const week = '星期' + '日一二三四五六'.charAt(time.getDay())
  return `${week}`
}

export const formateDateShm = (date) => {
  const time = new Date(date)
  const hour = complement(time.getHours())
  const minute = complement(time.getMinutes())
  const second = complement(time.getSeconds())
  return `${hour}:${minute}:${second}`
}
/*
 * XXXX年XX月XX日XX时XX分XX秒 【数字格式】
 */

export const formatTime = (data, flag) => {
  const date = new Date(data)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? '0' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  minute = minute < 10 ? '0' + minute : minute
  let second = date.getSeconds()
  second = second < 10 ? '0' + second : second
  if (flag) {
    return y + '-' + m + '-' + d
  }
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
}

// 校验整数
export function isInteger(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'))
  }
  setTimeout(() => {
    const re = /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/
    const rsCheck = re.test(value)
    if (!rsCheck) {
      callback(new Error('请输入整数'))
    } else {
      callback()
    }
  }, 0)
}

// 长整型校验
export function isIntegerToLong(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'))
  }
  setTimeout(() => {
    if (value < -2147483647 || value > 2147483647) {
      callback(new Error('数值范围超出，请重新输入'))
    } else {
      const re = /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/
      const rsCheck = re.test(value)
      if (!rsCheck) {
        callback(new Error('请输入整数'))
      } else {
        callback()
      }
    }
  }, 0)
}

// 保留三位小数的整数(包括0)
export function isIntegerToDouble(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'))
  }
  setTimeout(() => {
    if (value < 0 || value > 21312312312312) {
      callback(new Error('数值范围越出，请重新输入'))
    } else {
      const re =
        /(^[0-9]([0-9]+)?(\.[0-9]{1,3})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      const rsCheck = re.test(value)
      if (!rsCheck) {
        callback(new Error('请输入最多三位小数的正数'))
      } else {
        callback()
      }
    }
  }, 0)
}

/* 新增元素方法**/
export function addItem(item, itemId, layout) {
  // 初始化元素
  const newItem = {
    ...item,
    i: itemId,
    x: 0,
    y: 0,
    w: item.w,
    h: item.h
  }
  // 确定边界
  const Ys = []
  const maxX = 0
  let maxY = 0
  let edgeX = 0
  let edgeY = 0
  layout.map((item) => {
    Ys.push(item.y + item.h)
  })
  maxY = (Ys.length && Math.max.apply(null, Ys)) || 1
  edgeX = 12
  edgeY = maxY
  // 使用二维数组生成地图
  const gridMap = new Array()
  for (let x = 0; x < edgeX; x++) {
    gridMap[x] = new Array()
    for (let y = 0; y < edgeY; y++) {
      gridMap[x][y] = 0
    }
  }
  // 标记占位
  layout.map((item) => {
    // 将layout中卡片所占区域标记为1
    for (let x = item.x; x < item.x + item.w; x++) {
      for (let y = item.y; y < item.y + item.h; y++) {
        gridMap[x][y] = 1
      }
    }
  })
  // 遍历地图，申请位置
  for (let y = 0; y < edgeY; y++) {
    for (let x = 0; x < edgeX; x++) {
      // 申请所需空间
      if (edgeX - x >= item.w && edgeY - y >= item.h) {
        const itemSignArr = []
        for (let a = x; a < x + item.w; a++) {
          for (let b = y; b < y + item.h; b++) {
            itemSignArr.push(gridMap[x][y])
          }
        }
        if (itemSignArr.indexOf(1) < 0) {
          newItem.x = x
          newItem.y = y
          layout.push(newItem)
          return
        }
      }
    }
  }
  // 无满足条件
  newItem.x = 0
  newItem.y = edgeY + 1
  layout.push(newItem)
}

export const validateNumber = (rule, value, callback) => {
  const numberReg = /^\d+$|^\d+[.]?\d+$/
  if (value !== '') {
    if (!numberReg.test(value)) {
      callback(new Error('请输入数字'))
    } else {
      callback()
    }
  } else {
    callback(new Error('请输入值'))
  }
}

// 校验邮箱格式正则表达式
export const checkEmail = (rule, value, callback) => {
  const re = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
  const rsCheck = re.test(value)
  if (!rsCheck) {
    callback(new Error('请输入正确账号格式'))
  } else {
    callback()
  }
}
// 校验邮箱和手机号格式正则表达式
export const checkEmailPhone = (rule, value, callback) => {
  const re =
    /(^[\w.\-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$)|(^1[3|4|5|8]\d{9}$)/
  const rsCheck = re.test(value)
  if (!rsCheck) {
    callback(new Error('只能输入手机号或者邮箱格式'))
  } else {
    callback()
  }
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  const config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  }

  const childrenListMap = {}
  const nodeIds = {}
  const tree = []

  for (const d of data) {
    const parentId = d[config.parentId]
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = []
    }
    nodeIds[d[config.id]] = d
    childrenListMap[parentId].push(d)
  }

  for (const d of data) {
    const parentId = d[config.parentId]
    if (nodeIds[parentId] == null) {
      tree.push(d)
    }
  }

  for (const t of tree) {
    adaptToChildrenList(t)
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]]
    }
    if (o[config.childrenList]) {
      for (const c of o[config.childrenList]) {
        adaptToChildrenList(c)
      }
    }
  }

  return tree
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields()
  }
}

// 强制性el-button失去焦点
export function elButtonblur(e) {
  let target = e.target
  if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
    target = e.target.parentNode
  }
  target.blur()
}

export function compare(property) {
  return function (a, b) {
    const value1 = a[property]
    const value2 = b[property]
    return value1 - value2
  }
}

export function compareDown(property) {
  return function (a, b) {
    const value1 = a[property]
    const value2 = b[property]
    return value2 - value1
  }
}

// 转意符 换成普通字符
export function escape2Html(str) {
  const arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '"' }
  return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
    return arrEntities[t]
  })
}

/* 移除HTML标签代码 */
export function removeHTMLTag(str, length = 0) {
  str = str.replace(/<\/?[^>]*>/g, '') // 去除HTML tag
  str = str.replace(/[ | ]*\n/g, '\n') // 去除行尾空白
  // str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
  str = str.replace(/ /gi, '') // 去掉

  // 如果展示指定长度的字符，并使用省略号
  if (length > 0) {
    if (length < str.length) {
      return str.slice(0, length) + '......'
    }
  }
  return str
}

// 将树形转为数组
// 递归
// 1. 结束条件 treeData为空，返回[]
// 2. 结束条件 treeData不为空 返回[当前元素].concat(transfer(子元素))
// 需要实现transfer函数, 输入树形结构, 输出结果为一个一维数组:arrayData
export function transfer(treeData) {
  // for (const i in treeData) {
  if (!(!treeData.hasOwnProperty('key') || !treeData)) {
    let arr = []
    const obj = {}
    obj.name = treeData.key
    obj.value = treeData.doc_count
    if (treeData.child_buckets) {
      obj.child_buckets = treeData.child_buckets.map((item) => {
        const id = {
          name: item.key,
          value: item.doc_count
        }
        return id
      })
    }
    arr.push(obj)
    // 这段代码可由代码 [1] 替代，替代后父元素在子元素后
    if (treeData.child_buckets) {
      treeData.child_buckets.forEach((value) => {
        arr = arr.concat(transfer(value))
      })
    } else {
      // eslint-disable-next-line no-unused-expressions
      arr.splice
    }
    //
    return arr
  } else {
    // 初始treeData是否为空树
    return []
  }
  // }
}

// seq随机数
export const getRandom = () => {
  const str = '0123456789'
  let s = ''
  for (let i = 0; i < 8; i++) {
    const num = Math.round(Math.random() * str.length)
    s += str.charAt(num)
  }
  console.error('seq：', s)
  return s
}

// 非空判断
// eslint-disable-next-line camelcase
export function isNull_Any(data) {
  let fag = true
  // eslint-disable-next-line valid-typeof
  if (data != null && typeof data !== undefined && data !== '') {
    fag = false
  }
  return fag
}

// 去除字符串中的空格
export function empty(value) {
  return value.replace(/\s+/g, '')
}

// 获取粘贴内容
export function getCopyText(callback) {
  return new Promise((resolve, reject) => {
    // 获取权限
    navigator.permissions
      .query({
        name: 'clipboard-read'
      })
      .then((result) => {
        if (result.state === 'granted' || result.state === 'prompt') {
          // 读取剪贴板
          navigator.clipboard.readText().then((data) => {
            console.log(data)
            resolve(data)
          })
        } else {
          alert('请允许读取剪贴板！')
          // eslint-disable-next-line prefer-promise-reject-errors
          reject()
        }
      })
      .catch((e) => {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject()
      })
  })
}

/**
 * 随机颜色
 */
export function randomColor() {
  return '#' + Math.floor(Math.random() * 0xffffff).toString(16)
}

export const toJsonUtil = (data) => {
  try {
    if (typeof JSON.parse(data) === 'object') {
      return JSON.parse(data)
    }
  } catch (e) {
    return data
  }
}

// 清除指定cookie
export function removeCookie(cname) {
  let name = cname + '='
  let ca = document.cookie.split(';')
  let cookieStr = ''
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim()
    if (c.indexOf(name) == 0) {
      document.cookie = c + ';expires=' + new Date(0).toUTCString()
    } else {
      cookieStr += c
      cookieStr += ';'
    }
    document.cookie = cookieStr
  }
}
